exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.apex-chart-container[data-v-11f99f4f] {\n    width: 100%; /* Ustaw szerokość na 100% */\n}\n.apexcharts-xaxis-label[data-v-11f99f4f]:nth-last-child(2) {\n    transform: translateX(-20px)\n}\n", ""]);

// exports
